import React, { useEffect } from "react";
import LNavbar from "../landingPage/LNavbar";
import Banner from "../landingPage/Banner";
import styled from "styled-components";
import ManageYour from "../landingPage/ManageYour";
import Tasks from "../landingPage/Tasks";
import Habits from "../landingPage/Habits";
import GoalShawcase from "../landingPage/GoalShowcase";
import FinancesShowcase from "../landingPage/FinanceShowcase";
import PricingPage from "../landingPage/PricingPage";
import WorkHourCounterShowcase from "../landingPage/WorkHourCounterShowcase";
import ContactUs from "./ContactUs";

const LandingPage = ({ theme, switchTheme }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "ASites Planner";
  }, []);
  return (
    <Container>
      <LNavbar theme={theme} switchTheme={switchTheme} />

      {/* We removed the padding here. 
          If your Banner has a margin-top inside it, that is what causes the gap.
      */}
      <Content>
        <Banner />

        <DesktopOnly>
          <ManageYour />
        </DesktopOnly>

        <Tasks />
        <Habits />
        <FinancesShowcase />
        <GoalShawcase />
        <WorkHourCounterShowcase />
        <PricingPage />
        <ContactUs />
      </Content>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  &::before {
    content: "";
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background-color: #08040c;
    background-image: radial-gradient(
      circle at 70% 23%,
      #2b224d 0%,
      #120818 45%,
      #08040c 70%
    );
    background-repeat: no-repeat;
    background-size: cover;
  }
`;

const Content = styled.main`
  position: relative;
  z-index: 1;
  width: 100%;
  /* If there is still a gap, check the Banner.js component 
     for 'margin-top' or 'padding-top' and set it to 0.
  */
  margin: 0;
  padding: 0;
`;

const DesktopOnly = styled.div`
  @media (max-width: 1400px) {
    display: none;
  }
`;

export default LandingPage;
